import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LottieComponent, AnimationOptions } from "ngx-lottie";


const variantNumber = [1, 2, 3] as const;
type Variant = `animation${typeof variantNumber[number]}`; 


@Component({
  selector: "app-lottie-component",
  templateUrl: "./lottie-component.component.html",
  styleUrls: ["./lottie-component.component.scss"],

  
})
export class LottieComponentComponent implements OnInit {
  @Input() public path?: string;
  @Input() public variantClass?: string;
  segmentStart = 0;

  public lottieOptions: AnimationOptions = {};

  ngOnInit(): void {
    const getVariant =
      this.changeTheAnimationStyleAccordingToThePath(this.path!) ?? undefined;

    this.variantClass = this.applyVariantClass(getVariant as Variant);

    this.lottieOptions = {
      path: this.path,
      loop: false,
      renderer: "svg",
      autoplay: true,
    };
  }

  changeTheAnimationStyleAccordingToThePath(_path: string): string | void {
    if (!_path) return;

    const path = _path;
    const extractedValue = path.match(/\/([^/]+)\.json$/);

    if (extractedValue && Array.isArray(extractedValue))
      return extractedValue![1];
  }

  applyVariantClass(variant: Variant): string {
    const variantsClass = {
      animation1: "lottie--primary-banner",
      animation2: "lottie--secondary-banner",
      animation3: "lottie--third-banner",
    };
    return variantsClass?.[variant] ?? "lottie--primary-banner";
  }


}
